import { globals } from "@/main";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const emailValue =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/gm;
export const stringRegex =
  /^[^\d`~!@#$%^&*[\]([\])_+-=[\][\][\]{[\]}[\]|\\;':",./<>?]*$/gm;
export const numberValue = /^[\d]*$/gm;
export const numberSpaceValue = /^[\d.]*$/gm;
export const numberStringValue = /^[a-zA-Z\d]*$/gm;
export const stringSpecialValue = /^[a-zA-Z]*$/gm;
export const decimalValue = /^-?((0(\.\d{1,2})?)|([1-9]\d*(\.\d{1,2})?))$/gm;
export const discountValue = /^[\d.%$]*$/gm;
export const redirectTimer = 300;
export const reconnectTimer = 6000;
export const submitFormDelay = 500;
export const removeFeedbackDelay = 3000;
export const fileSize: number = 5 * 1024 * 1024;
export const imageSupportedFormat: string[] = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/svg",
];

interface Validator {
  error: string[];
  number(value: number): Validator;
  numberRequired(value: number): Validator;
  decimal(value: number): Validator;
  required(value: string | number | object | any[]): Validator;
  dateIsAfter(startDate: string, endDate: string, msg?: string): Validator;
  notAllowWhitespace(value: string): Validator;
  isEmail(value: string): Validator;
  isMinLength(value: string, minLength: number): Validator;
  isMaxLength(value: string, maxLength: number): Validator;
}

export const schema = (): Validator => {
  const validator: Validator = {
    error: [],

    dateIsAfter(startDate, endDate, msg) {
      if (globals.$moment(startDate).isAfter(endDate, "day")) {
        this.error.push(msg || "messageDateIsAfter");
      }
      return this;
    },
    notAllowWhitespace(value) {
      const lowercaseRegex = /\s/;
      if (lowercaseRegex.test(value)) {
        this.error.push("messageWhiteSpaceIsNotPermitted");
      }
      return this;
    },
    isEmail(value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const validEmail = emailRegex.test(value);
      if (value && !validEmail) {
        this.error.push("Invalid email");
      }
      return this;
    },
    isMinLength(value, minLength) {
      if (value && value.length < minLength) {
        this.error.push(`Value must be at least ${minLength}`);
      }
      return this;
    },

    isMaxLength(value, maxLength) {
      if (value && value.length > maxLength) {
        this.error.push(`The value must not exceed ${maxLength} characters. `);
      }
      return this;
    },
    number(value) {
      const numberRegex = /^\d*$/;

      if (!numberRegex.test(value.toString())) {
        this.error.push("messageValueIsNotAValidNumber");
      }
      return this;
    },

    numberRequired(value) {
      if (!Number(value)) {
        this.error.push("messageFieldIsRequired");
      }
      return this;
    },

    decimal(value) {
      const decimalRegex = /^\d*\.?\d*$/;

      if (!decimalRegex.test(value.toString())) {
        this.error.push("messageValueIsNotAValidDecimal");
      }
      return this;
    },

    required(value) {
      if (
        typeof value === "string" ||
        typeof value === "object" ||
        typeof value === "number" ||
        Array.isArray(value)
      ) {
        if (
          (typeof value === "number" &&
            (isNaN(value) || value.toString() === "NaN")) ||
          !String(value) ||
          value === null ||
          (Array.isArray(value) && value.length === 0)
        ) {
          this.error.push("messageFieldIsRequired");
        } else if (typeof value === "string" && value.trim().length === 0) {
          this.error.push("messageWhiteSpaceIsNotPermitted");
        } else if (typeof value === "string" && value.startsWith(" ")) {
          this.error.push("messageValueCannotBeginWithASpace");
        }
      } else {
        // value = String(value);

        if (!value) {
          this.error.push("messageFieldIsRequired");
        }
      }

      return this;
    },
  };

  return validator;
};
